export default __webpack_public_path__ + "static/hq7-90a3d6d49129a4319f83142aa5d64998.jpg";